module.exports = __webpack_public_path__ + "img/mini_marker_dark.5c905e50.svg";